/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SinglePlayerRatingExplanation = {
    properties: {
        playerId: {
            type: 'number',
            isRequired: true,
        },
        givenName: {
            type: 'string',
            isRequired: true,
        },
        familyName: {
            type: 'string',
            isRequired: true,
        },
        rawScoreSum: {
            type: 'number',
            isRequired: true,
        },
        normalizedRating: {
            type: 'number',
            isRequired: true,
        },
        teamId: {
            type: 'number',
            isRequired: true,
        },
        teamName: {
            type: 'string',
            isRequired: true,
        },
        explanations: {
            type: 'dictionary',
            contains: {
                type: 'number',
            },
            isRequired: true,
        },
    },
} as const;
